import DatabaseModel from './DatabaseModel.js';

var Albaran = Object.create(DatabaseModel);

Albaran.model = 'albaran';
Albaran.modelFront = 'albaranes';

export default Albaran;